export default __webpack_public_path__ + "static/media/prague-statue.81371c89.png";